import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface NameDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  firstName: string
  lastName: string
  onFirstNameChange: (value: string) => void
  onLastNameChange: (value: string) => void
  onSave: () => void
  isPending: boolean
  isValid: boolean
}

export function NameDialog({
  open,
  onOpenChange,
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  onSave,
  isPending,
  isValid,
}: NameDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <form
          onSubmit={(e) => {
            e.preventDefault()
            if (isValid) onSave()
          }}
        >
          <DialogHeader>
            <DialogTitle>{t('settings.dialogs.name.title')}</DialogTitle>
            <DialogDescription>{t('settings.dialogs.name.description')}</DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4 sm:grid-cols-2">
            <div className="flex flex-col gap-1.5">
              <label className="text-sm font-medium" htmlFor="settings-first-name">
                {t('settings.dialogs.name.firstName')}
              </label>
              <Input
                id="settings-first-name"
                value={firstName}
                onChange={(e) => onFirstNameChange(e.target.value)}
                autoComplete="given-name"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-sm font-medium" htmlFor="settings-last-name">
                {t('settings.dialogs.name.lastName')}
              </label>
              <Input
                id="settings-last-name"
                value={lastName}
                onChange={(e) => onLastNameChange(e.target.value)}
                autoComplete="family-name"
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              {t('common.cancel')}
            </Button>
            <Button type="submit" disabled={isPending || !isValid}>
              {isPending ? t('settings.dialogs.name.saving') : t('settings.dialogs.name.save')}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
